module.exports = __webpack_public_path__ + "videos/video-aleo-ads.287370b.mp4";